// ZZYON LEX — main entry. Vanilla JS + Vite (alinhado com torre-frota).
// Tabs: dashboard · processos · alertas · licencas · dossies · consultas

import './styles.css';
import './lex-logo.js';
import { openModal, closeModal } from './lex-modal.js';
import { renderDropzoneEPreview } from './lex-importer-ui.js';
import { renderFormLicenca } from './lex-licencas.js';
import { renderPaineisProcesso } from './lex-processo-detalhe.js';
import { renderContratos, renderContratoDetalhe } from './lex-contratos.js';
import {
  lex, lexAuth,
  isIcaroEmail, signInMagic, signOut, getCurrentUser,
  fetchProcessos, fetchProcesso, fetchMovimentacoes,
  fetchAlertas, marcarAlertaLido,
  fetchDossies, fetchLicencasVencendo, fetchProvisoesResumo,
  fetchUltimasConsultas, fetchParecer,
} from './lex-client.js';
import {
  fmtBRL, fmtDate, fmtDateTime, fromNow, escapeHtml,
  severidadeBadge, riscoBadge, criticidadeBadge, mdToHtml,
} from './utils.js';

const $ = (sel, root = document) => root.querySelector(sel);
const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

// ─── Bootstrap ─────────────────────────────────────────────────────
async function boot() {
  // Listener de auth — re-render ao login/logout
  lexAuth.auth.onAuthStateChange((event, session) => {
    if (event === 'SIGNED_IN' || event === 'SIGNED_OUT' || event === 'TOKEN_REFRESHED') {
      route();
    }
  });
  await route();
  window.addEventListener('hashchange', route);
}

async function route() {
  const user = await getCurrentUser();
  if (!user) return renderLogin();

  if (user.email && !isIcaroEmail(user.email)) {
    return renderBlocked(user.email);
  }

  const tab = (location.hash.slice(1) || 'dashboard').split('/')[0];
  renderShell(user, tab);
}

// ─── Login ─────────────────────────────────────────────────────────
function renderLogin() {
  $('#app').innerHTML = `
    <div class="lex-login-wrap">
      <div class="lex-login-card">
        <div style="display:flex;justify-content:center;margin-bottom:18px;color:#fff">
          <lex-logo size="56" sub="true"></lex-logo>
        </div>
        <h1>Plataforma jurídica</h1>
        <div class="tagline">Inteligência em órbita — para o jurídico</div>

        <input id="lex-email" type="email" autocomplete="email"
               placeholder="seu.nome@icaroexpress.com"
               class="lex-input" />
        <button id="lex-login-btn" class="lex-btn">Receber link de acesso</button>
        <div id="lex-msg" class="lex-msg"></div>

        <div class="lex-foot">
          Apenas e-mails <strong>@icaroexpress.com</strong> têm acesso.<br>
          Em caso de dúvida, fale com TI.
        </div>
      </div>
    </div>
  `;

  $('#lex-login-btn').addEventListener('click', async () => {
    const email = $('#lex-email').value.trim();
    const msg = $('#lex-msg');
    msg.className = 'lex-msg';
    msg.textContent = '';
    if (!email) {
      msg.textContent = 'Informe um e-mail.';
      msg.classList.add('err');
      return;
    }
    if (!isIcaroEmail(email)) {
      msg.textContent = 'Apenas @icaroexpress.com.';
      msg.classList.add('err');
      return;
    }
    $('#lex-login-btn').disabled = true;
    try {
      await signInMagic(email, location.origin);
      msg.textContent = 'Link enviado! Verifique seu e-mail.';
      msg.classList.add('ok');
    } catch (err) {
      msg.textContent = 'Erro: ' + (err.message || err);
      msg.classList.add('err');
    } finally {
      $('#lex-login-btn').disabled = false;
    }
  });
}

function renderBlocked(email) {
  $('#app').innerHTML = `
    <div class="lex-login-wrap">
      <div class="lex-login-card">
        <div style="display:flex;justify-content:center;margin-bottom:18px;color:#fff">
          <lex-logo size="48" sub="true"></lex-logo>
        </div>
        <div class="lex-login-eyebrow">Acesso restrito</div>
        <h1>Domínio não autorizado</h1>
        <div class="tagline">${escapeHtml(email)}</div>
        <p style="font-size:13px;color:rgba(255,255,255,0.7);margin:20px 0">
          ZZYON LEX é restrito a usuários com e-mail <strong>@icaroexpress.com</strong>.
          Você está logado com outro domínio.
        </p>
        <button id="lex-signout" class="lex-btn">Sair e tentar novamente</button>
      </div>
    </div>
  `;
  $('#lex-signout').addEventListener('click', async () => {
    await signOut();
    location.hash = '';
    route();
  });
}

// ─── Shell ─────────────────────────────────────────────────────────
const TABS = [
  { id: 'dashboard',  label: 'Dashboard'  },
  { id: 'processos',  label: 'Processos'  },
  { id: 'contratos',  label: 'Contratos'  },
  { id: 'alertas',    label: 'Alertas'    },
  { id: 'licencas',   label: 'Licenças'   },
  { id: 'dossies',    label: 'Dossiês'    },
  { id: 'consultas',  label: 'Consultas'  },
];

function renderShell(user, activeTab) {
  $('#app').innerHTML = `
    <div class="lex-shell">
      <header class="lex-topbar">
        <div style="color:#fff">
          <lex-logo size="32" sub="true"></lex-logo>
        </div>
        <div style="display:flex;align-items:center;gap:14px;font-size:12px;color:rgba(255,255,255,0.7)">
          <span>${escapeHtml(user.email || '')}</span>
          <button id="lex-signout" class="lex-tab" style="padding:6px 10px;border:1px solid rgba(255,255,255,0.12);border-radius:6px">Sair</button>
        </div>
      </header>
      <nav class="lex-tabs">
        ${TABS.map(t => `
          <button class="lex-tab ${t.id === activeTab ? 'active' : ''}" data-tab="${t.id}">
            ${t.label}
          </button>
        `).join('')}
      </nav>
      <main id="lex-main" class="lex-main">
        <div style="text-align:center;padding:40px"><span class="lex-spin"></span></div>
      </main>
    </div>
  `;

  $('#lex-signout').addEventListener('click', async () => {
    await signOut();
    location.hash = '';
    route();
  });

  $$('.lex-tab').forEach(btn => {
    btn.addEventListener('click', () => {
      const tab = btn.dataset.tab;
      if (!tab) return;
      location.hash = tab;
    });
  });

  loadTab(activeTab, user);
}

async function loadTab(tab, user) {
  const main = $('#lex-main');
  try {
    if (tab === 'dashboard')  return await renderDashboard(main);
    if (tab === 'processos')  {
      const sub = location.hash.slice(1).split('/');
      if (sub[1]) return await renderProcessoDetalhe(main, decodeURIComponent(sub[1]), user);
      return await renderProcessosLista(main);
    }
    if (tab === 'contratos')  {
      const sub = location.hash.slice(1).split('/');
      if (sub[1]) return await renderContratoDetalhe(main, decodeURIComponent(sub[1]), user);
      return await renderContratos(main);
    }
    if (tab === 'alertas')    return await renderAlertas(main, user);
    if (tab === 'licencas')   return await renderLicencas(main);
    if (tab === 'dossies')    return await renderDossies(main);
    if (tab === 'consultas')  {
      const sub = location.hash.slice(1).split('/');
      if (sub[1]) return await renderConsultaDetalhe(main, decodeURIComponent(sub[1]));
      return await renderConsultasLista(main);
    }
    main.innerHTML = `<div class="lex-empty">Aba não implementada.</div>`;
  } catch (err) {
    console.error(err);
    main.innerHTML = `
      <div class="lex-section">
        <h2>Erro</h2>
        <div class="lex-empty">${escapeHtml(err.message || String(err))}</div>
      </div>`;
  }
}

// ─── Dashboard ─────────────────────────────────────────────────────
async function renderDashboard(main) {
  const [processos, alertas, licencas, dossies, provisoes, consultas] = await Promise.all([
    fetchProcessos({ limit: 5 }),
    fetchAlertas({ limit: 50, naoLidos: true }),
    fetchLicencasVencendo(),
    fetchDossies({ limit: 5 }),
    fetchProvisoesResumo(),
    fetchUltimasConsultas({ limit: 5 }),
  ]);

  const totalProvisao = (provisoes || []).reduce((s, r) => s + Number(r.soma_provisao || 0), 0);
  const licCriticas = (licencas || []).filter(l => ['vencida','critica','urgente'].includes(l.criticidade)).length;
  const alertasCrit = (alertas || []).filter(a => a.severidade === 'critical').length;

  main.innerHTML = `
    <div class="lex-grid-cards">
      <div class="lex-card accent">
        <div class="label">Processos ativos</div>
        <div class="value">${processos?.length ?? 0}</div>
        <div class="sub">${processos?.length ? 'Mais recentes na lista abaixo' : 'Nenhum cadastrado'}</div>
      </div>
      <div class="lex-card">
        <div class="label">Provisão total</div>
        <div class="value">${fmtBRL(totalProvisao)}</div>
        <div class="sub">Risco provável + possível</div>
      </div>
      <div class="lex-card">
        <div class="label">Alertas pendentes</div>
        <div class="value">${alertas?.length ?? 0}</div>
        <div class="sub">${alertasCrit} crítico(s)</div>
      </div>
      <div class="lex-card">
        <div class="label">Licenças vencendo</div>
        <div class="value">${licCriticas}</div>
        <div class="sub">${(licencas || []).length} em ≤90 dias</div>
      </div>
      <div class="lex-card">
        <div class="label">Dossiês ativos</div>
        <div class="value">${dossies?.length ?? 0}</div>
        <div class="sub">Casos em andamento</div>
      </div>
      <div class="lex-card">
        <div class="label">Consultas IA</div>
        <div class="value">${consultas?.length ?? 0}</div>
        <div class="sub">Últimas 5 mostradas em /consultas</div>
      </div>
    </div>

    ${renderRecentProcessosTable(processos || [])}
    ${renderRecentAlertasTable((alertas || []).slice(0, 6))}
  `;

  $$('[data-cnj]', main).forEach(tr =>
    tr.addEventListener('click', () => { location.hash = `processos/${encodeURIComponent(tr.dataset.cnj)}`; })
  );
  $$('[data-nav]', main).forEach(tr =>
    tr.addEventListener('click', () => { location.hash = tr.dataset.nav; })
  );
}

function renderRecentProcessosTable(rows) {
  if (!rows.length) {
    return `
      <div class="lex-section">
        <h2>Processos recentes</h2>
        <div class="lex-empty">Nenhum processo cadastrado ainda.<br>
        Use <code>themis.scripts.import_processos</code> para popular o banco.</div>
      </div>`;
  }
  return `
    <div class="lex-section">
      <h2>Processos recentes <span class="count">${rows.length}</span></h2>
      <table class="lex-table">
        <thead><tr>
          <th>CNJ</th><th>Tribunal</th><th>Contraparte</th>
          <th>Valor causa</th><th>Risco</th><th>Última mov.</th>
        </tr></thead>
        <tbody>
          ${rows.map(p => {
            const r = riscoBadge(p.risco);
            return `
              <tr data-cnj="${escapeHtml(p.numero_cnj)}">
                <td><strong>${escapeHtml(p.numero_cnj)}</strong></td>
                <td>${escapeHtml(p.tribunal || '—')}</td>
                <td>${escapeHtml(p.contraparte || '—')}</td>
                <td>${fmtBRL(p.valor_causa)}</td>
                <td><span class="${r.cls}">${r.txt}</span></td>
                <td>${fmtDate(p.ultima_movimentacao_data)}</td>
              </tr>`;
          }).join('')}
        </tbody>
      </table>
    </div>`;
}

function renderRecentAlertasTable(rows) {
  if (!rows.length) {
    return `
      <div class="lex-section">
        <h2>Alertas recentes</h2>
        <div class="lex-empty">Nenhum alerta pendente. Tudo sob controle.</div>
      </div>`;
  }
  return `
    <div class="lex-section">
      <h2>Alertas recentes <span class="count">${rows.length}</span></h2>
      <table class="lex-table">
        <thead><tr>
          <th>Quando</th><th>Severidade</th><th>Tipo</th><th>Título</th><th>Filial</th>
        </tr></thead>
        <tbody>
          ${rows.map(a => {
            const b = severidadeBadge(a.severidade);
            const nav = alertaNavTarget(a);
            return `
              <tr ${nav ? `data-nav="${nav}" style="cursor:pointer" title="Abrir detalhe"` : ''}>
                <td>${fromNow(a.ts)}</td>
                <td><span class="${b.cls}">${b.txt}</span></td>
                <td>${escapeHtml(a.tipo)}</td>
                <td>${escapeHtml(a.titulo)}</td>
                <td>${escapeHtml(a.filial_codigo || '—')}</td>
              </tr>`;
          }).join('')}
        </tbody>
      </table>
    </div>`;
}

// ─── Processos ─────────────────────────────────────────────────────
async function renderProcessosLista(main) {
  const rows = await fetchProcessos({ limit: 200 });
  main.innerHTML = `
    <div class="lex-toolbar">
      <button class="lex-btn-secondary" id="lex-import-procs">+ Importar processos</button>
    </div>
    <div class="lex-section">
      <h2>Processos <span class="count">${rows.length}</span></h2>
      ${rows.length ? `
        <table class="lex-table">
          <thead><tr>
            <th>CNJ</th><th>Área</th><th>Tribunal</th><th>Vara</th>
            <th>Filial</th><th>Contraparte</th>
            <th>Valor causa</th><th>Provisão</th><th>Risco</th><th>Última mov.</th>
          </tr></thead>
          <tbody>
            ${rows.map(p => {
              const r = riscoBadge(p.risco);
              return `
                <tr data-cnj="${escapeHtml(p.numero_cnj)}">
                  <td><strong>${escapeHtml(p.numero_cnj)}</strong></td>
                  <td><span class="lex-badge lex-badge-bronze">${escapeHtml(p.area_codigo || '—')}</span></td>
                  <td>${escapeHtml(p.tribunal || '—')}</td>
                  <td>${escapeHtml(p.vara || '—')}</td>
                  <td>${escapeHtml(p.filial_codigo || '—')}</td>
                  <td>${escapeHtml(p.contraparte || '—')}</td>
                  <td>${fmtBRL(p.valor_causa)}</td>
                  <td>${fmtBRL(p.valor_provisao)}</td>
                  <td><span class="${r.cls}">${r.txt}</span></td>
                  <td>${fmtDate(p.ultima_movimentacao_data)}</td>
                </tr>`;
            }).join('')}
          </tbody>
        </table>
      ` : `<div class="lex-empty">Nenhum processo cadastrado.</div>`}
    </div>
  `;
  $$('[data-cnj]', main).forEach(tr =>
    tr.addEventListener('click', () => { location.hash = `processos/${encodeURIComponent(tr.dataset.cnj)}`; })
  );

  $('#lex-import-procs', main)?.addEventListener('click', () => abrirImportProcessos(main));
}

function abrirImportProcessos(main) {
  const ui = renderDropzoneEPreview({
    onCancel: closeModal,
    onSuccess: (result) => {
      closeModal();
      const lines = [];
      if (result.inseridos)   lines.push(`${result.inseridos} novo(s)`);
      if (result.atualizados) lines.push(`${result.atualizados} atualizado(s)`);
      if (result.erros_db?.length) lines.push(`${result.erros_db.length} erro(s) de gravação`);
      alert('Import concluído: ' + (lines.join(' · ') || 'sem alterações'));
      renderProcessosLista(main);
    },
  });
  openModal({
    title: 'Importar processos (CSV/XLSX)',
    body: ui.body,
    footer: ui.footer,
    wide: true,
  });
}

async function renderProcessoDetalhe(main, cnj, user) {
  const proc = await fetchProcesso(cnj);
  if (!proc) {
    main.innerHTML = `
      <button class="lex-back">← voltar</button>
      <div class="lex-section"><div class="lex-empty">Processo ${escapeHtml(cnj)} não encontrado.</div></div>`;
    $('.lex-back', main).addEventListener('click', () => { location.hash = 'processos'; });
    return;
  }
  const movs = await fetchMovimentacoes(proc.id, { limit: 200 });
  const r = riscoBadge(proc.risco);

  main.innerHTML = `
    <button class="lex-back">← Processos</button>
    <div class="lex-section">
      <h2>${escapeHtml(proc.numero_cnj)}
        <span class="${r.cls}">${r.txt}</span>
      </h2>
      <div style="padding:18px 20px;display:grid;grid-template-columns:repeat(auto-fit,minmax(220px,1fr));gap:14px;font-size:13px">
        <div><div class="lex-key">Tribunal · Vara</div><div class="lex-val">${escapeHtml(proc.tribunal)} · ${escapeHtml(proc.vara || '—')}</div></div>
        <div><div class="lex-key">Comarca / UF</div><div class="lex-val">${escapeHtml(proc.comarca || '—')} / ${escapeHtml(proc.uf || '—')}</div></div>
        <div><div class="lex-key">Polo Ícaro</div><div class="lex-val">${escapeHtml(proc.polo)}</div></div>
        <div><div class="lex-key">Filial</div><div class="lex-val">${escapeHtml(proc.filial_codigo || '—')}</div></div>
        <div><div class="lex-key">Classe</div><div class="lex-val">${escapeHtml(proc.classe_processual || '—')}</div></div>
        <div><div class="lex-key">Assunto</div><div class="lex-val">${escapeHtml(proc.assunto || '—')}</div></div>
        <div><div class="lex-key">Contraparte</div><div class="lex-val">${escapeHtml(proc.contraparte || '—')}</div></div>
        <div><div class="lex-key">Advogado responsável</div><div class="lex-val">${escapeHtml(proc.advogado_responsavel || '—')}</div></div>
        <div><div class="lex-key">Valor causa</div><div class="lex-val">${fmtBRL(proc.valor_causa)}</div></div>
        <div><div class="lex-key">Provisão</div><div class="lex-val">${fmtBRL(proc.valor_provisao)}</div></div>
        <div><div class="lex-key">Distribuição</div><div class="lex-val">${fmtDate(proc.data_distribuicao)}</div></div>
        <div><div class="lex-key">Status</div><div class="lex-val">${escapeHtml(proc.status)}</div></div>
      </div>
    </div>

    <div id="lex-paineis-processo"></div>

    <div class="lex-section">
      <h2>Timeline DataJud <span class="count">${movs.length}</span></h2>
      <div style="padding:14px 20px">
        ${movs.length ? `
          <ul class="lex-timeline">
            ${movs.map(m => `
              <li>
                <div class="data">${fmtDate(m.data)}</div>
                <div class="nome">${escapeHtml(m.nome_movimento || '—')}</div>
              </li>
            `).join('')}
          </ul>
        ` : `<div class="lex-empty">Sem movimentações sincronizadas.</div>`}
      </div>
    </div>
  `;

  $('.lex-back', main).addEventListener('click', () => { location.hash = 'processos'; });

  // Painéis de risco/fato/pessoas/docs/ações
  await renderPaineisProcesso($('#lex-paineis-processo', main), proc, user?.email || '');
}

// ─── Alertas ───────────────────────────────────────────────────────
// Para onde um alerta navega ao ser clicado (CNJ no título → processo;
// recurso contrato → contrato; licença → aba licenças).
function alertaNavTarget(a) {
  if (a.recurso_tipo === 'contrato' && a.recurso_id) return `contratos/${a.recurso_id}`;
  const cnj = `${a.titulo || ''} ${a.mensagem || ''}`.match(/\d{7}-\d{2}\.\d{4}\.\d\.\d{2}\.\d{4}/);
  if (cnj) return `processos/${encodeURIComponent(cnj[0])}`;
  if ((a.tipo || '').startsWith('licenca')) return 'licencas';
  return '';
}

async function renderAlertas(main, user) {
  const rows = await fetchAlertas({ limit: 200 });
  main.innerHTML = `
    <div class="lex-section">
      <h2>Alertas <span class="count">${rows.length}</span></h2>
      ${rows.length ? `
        <table class="lex-table">
          <thead><tr>
            <th>Quando</th><th>Severidade</th><th>Tipo</th>
            <th>Título / Mensagem</th><th>Filial</th><th>Status</th><th></th>
          </tr></thead>
          <tbody>
            ${rows.map(a => {
              const b = severidadeBadge(a.severidade);
              const lido = a.lido_em ? `<span class="lex-badge lex-badge-ok">LIDO</span>` :
                                       `<span class="lex-badge lex-badge-warn">PENDENTE</span>`;
              const nav = alertaNavTarget(a);
              return `
                <tr ${nav ? `data-nav="${nav}" style="cursor:pointer" title="Abrir detalhe"` : ''}>
                  <td>${fmtDateTime(a.ts)}</td>
                  <td><span class="${b.cls}">${b.txt}</span></td>
                  <td>${escapeHtml(a.tipo)}</td>
                  <td>
                    <strong>${escapeHtml(a.titulo)}</strong><br>
                    <span style="color:rgba(255,255,255,0.6);font-size:12px">${escapeHtml(a.mensagem || '')}</span>
                  </td>
                  <td>${escapeHtml(a.filial_codigo || '—')}</td>
                  <td>${lido}</td>
                  <td>${a.lido_em ? '' : `<button class="lex-btn" style="padding:6px 10px;font-size:11px" data-lido="${a.id}">marcar lido</button>`}</td>
                </tr>`;
            }).join('')}
          </tbody>
        </table>
      ` : `<div class="lex-empty">Sem alertas.</div>`}
    </div>
  `;
  $$('[data-nav]', main).forEach(tr =>
    tr.addEventListener('click', () => { location.hash = tr.dataset.nav; })
  );
  $$('[data-lido]', main).forEach(btn => {
    btn.addEventListener('click', async (ev) => {
      ev.stopPropagation();
      btn.disabled = true; btn.textContent = '…';
      try {
        await marcarAlertaLido(btn.dataset.lido, user.email);
        await renderAlertas(main, user);
      } catch (e) {
        btn.textContent = 'erro';
      }
    });
  });
}

// ─── Licenças ──────────────────────────────────────────────────────
async function renderLicencas(main) {
  const rows = await fetchLicencasVencendo();
  main.innerHTML = `
    <div class="lex-toolbar">
      <button class="lex-btn-secondary" id="lex-nova-lic">+ Nova licença</button>
    </div>
    <div class="lex-section">
      <h2>Licenças vencendo (≤ 90 dias) <span class="count">${rows.length}</span></h2>
      ${rows.length ? `
        <table class="lex-table">
          <thead><tr>
            <th>Filial</th><th>Tipo</th><th>Nº</th><th>Órgão</th>
            <th>Validade</th><th>Dias</th><th>Custo renov.</th><th>Criticidade</th>
          </tr></thead>
          <tbody>
            ${rows.map(l => {
              const c = criticidadeBadge(l.criticidade);
              return `
                <tr>
                  <td>${escapeHtml(l.filial_codigo)}</td>
                  <td>${escapeHtml(l.tipo)}</td>
                  <td>${escapeHtml(l.numero || '—')}</td>
                  <td>${escapeHtml(l.orgao_emissor)}</td>
                  <td>${fmtDate(l.data_validade)}</td>
                  <td><strong>${l.dias_para_vencer}</strong></td>
                  <td>${fmtBRL(l.custo_renovacao_estimado)}</td>
                  <td><span class="${c.cls}">${c.txt}</span></td>
                </tr>`;
            }).join('')}
          </tbody>
        </table>
      ` : `<div class="lex-empty">Sem licenças vencendo nos próximos 90 dias.<br>Use "+ Nova licença" para cadastrar a primeira.</div>`}
    </div>
  `;

  $('#lex-nova-lic', main)?.addEventListener('click', () => abrirNovaLicenca(main));
}

function abrirNovaLicenca(main) {
  const ui = renderFormLicenca({
    onCancel: closeModal,
    onSubmit: () => {
      closeModal();
      renderLicencas(main);
    },
  });
  openModal({
    title: 'Cadastrar nova licença regulatória',
    body: ui.form,
    footer: ui.footer,
  });
}

// ─── Dossiês ───────────────────────────────────────────────────────
async function renderDossies(main) {
  const rows = await fetchDossies({ limit: 200 });
  main.innerHTML = `
    <div class="lex-section">
      <h2>Dossiês ativos <span class="count">${rows.length}</span></h2>
      ${rows.length ? `
        <table class="lex-table">
          <thead><tr>
            <th>Código</th><th>Título</th><th>Área</th><th>Natureza</th>
            <th>Status</th><th>Prioridade</th><th>Itens</th><th>Valor</th><th>Prazo</th>
          </tr></thead>
          <tbody>
            ${rows.map(d => {
              const prio = {
                critica: 'lex-badge lex-badge-crit',
                alta:    'lex-badge lex-badge-warn',
                media:   'lex-badge lex-badge-info',
                baixa:   'lex-badge lex-badge-ok',
              }[d.prioridade] || 'lex-badge lex-badge-info';
              return `
                <tr>
                  <td><strong>${escapeHtml(d.codigo)}</strong></td>
                  <td>${escapeHtml(d.titulo)}</td>
                  <td><span class="lex-badge lex-badge-bronze">${escapeHtml(d.area_codigo || '—')}</span></td>
                  <td>${escapeHtml(d.natureza || '—')}</td>
                  <td>${escapeHtml(d.status)}</td>
                  <td><span class="${prio}">${escapeHtml(d.prioridade || '')}</span></td>
                  <td>${d.qtd_itens ?? 0}</td>
                  <td>${fmtBRL(d.valor_envolvido)}</td>
                  <td>${fmtDate(d.prazo_finalizacao)}</td>
                </tr>`;
            }).join('')}
          </tbody>
        </table>
      ` : `<div class="lex-empty">Nenhum dossiê ativo.</div>`}
    </div>
  `;
}

// ─── Consultas ─────────────────────────────────────────────────────
async function renderConsultasLista(main) {
  const rows = await fetchUltimasConsultas({ limit: 50 });
  main.innerHTML = `
    <div class="lex-disclaimer">
      Consultas geradas pelos agentes <strong>THEMIS</strong> (LABOR/TAX/CORP/REG/CONTRACT/LIT).
      Toda saída é <strong>análise preliminar de IA</strong> — não substitui parecer formal.
    </div>
    <div class="lex-section">
      <h2>Consultas recentes <span class="count">${rows.length}</span></h2>
      ${rows.length ? `
        <table class="lex-table">
          <thead><tr>
            <th>Quando</th><th>Usuário</th><th>Pergunta</th>
            <th>Agentes</th><th>Duração</th>
          </tr></thead>
          <tbody>
            ${rows.map(c => `
              <tr data-id="${escapeHtml(c.id)}">
                <td>${fromNow(c.criado_em)}</td>
                <td>${escapeHtml((c.usuario_email || '').split('@')[0])}</td>
                <td>${escapeHtml((c.pergunta || '').slice(0, 100))}${(c.pergunta || '').length > 100 ? '…' : ''}</td>
                <td>${(c.agentes_consultados || []).map(a => `<span class="lex-badge lex-badge-bronze">${escapeHtml(a)}</span>`).join(' ')}</td>
                <td>${c.duracao_ms ? Math.round(c.duracao_ms/1000) + 's' : '—'}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>
      ` : `<div class="lex-empty">Nenhuma consulta registrada.</div>`}
    </div>
  `;
  $$('[data-id]', main).forEach(tr =>
    tr.addEventListener('click', () => { location.hash = `consultas/${encodeURIComponent(tr.dataset.id)}`; })
  );
}

async function renderConsultaDetalhe(main, consultaId) {
  const { data: consulta } = await lex.from('consultas').select('*').eq('id', consultaId).maybeSingle();
  if (!consulta) {
    main.innerHTML = `<button class="lex-back">← voltar</button><div class="lex-section"><div class="lex-empty">Consulta não encontrada.</div></div>`;
    $('.lex-back', main).addEventListener('click', () => { location.hash = 'consultas'; });
    return;
  }
  const { data: pareceres } = await lex
    .from('pareceres')
    .select('*')
    .eq('consulta_id', consultaId)
    .order('criado_em');

  const consolidado = (pareceres || []).find(p => p.agente === 'themis-orchestrator');
  const individuais = (pareceres || []).filter(p => p.agente !== 'themis-orchestrator');

  main.innerHTML = `
    <button class="lex-back">← Consultas</button>
    <div class="lex-section">
      <h2>Consulta · ${fromNow(consulta.criado_em)}</h2>
      <div style="padding:16px 20px">
        <div class="lex-key">Pergunta</div>
        <p style="font-size:14px;color:#fff;margin:6px 0 0 0">${escapeHtml(consulta.pergunta)}</p>
        <div style="margin-top:14px;display:flex;gap:18px;flex-wrap:wrap;font-size:12px">
          <div><span class="lex-key">Usuário:</span> <span class="lex-val">${escapeHtml(consulta.usuario_email || '—')}</span></div>
          <div><span class="lex-key">Duração:</span> <span class="lex-val">${consulta.duracao_ms ? Math.round(consulta.duracao_ms/1000) + 's' : '—'}</span></div>
          <div><span class="lex-key">Agentes:</span>
            ${(consulta.agentes_consultados || []).map(a => `<span class="lex-badge lex-badge-bronze">${escapeHtml(a)}</span>`).join(' ')}
          </div>
        </div>
      </div>
    </div>

    ${consolidado ? `
      <div class="lex-section">
        <h2>Parecer consolidado</h2>
        <div style="padding:18px 24px;line-height:1.6;font-size:14px">
          ${mdToHtml(consolidado.parecer_markdown || '')}
        </div>
        <div style="padding:0 24px 18px;font-size:11px;color:rgba(255,255,255,0.5)">
          Modelo: ${escapeHtml(consolidado.modelo_llm || '')} · tokens: ${consolidado.tokens_input || 0} in / ${consolidado.tokens_output || 0} out
        </div>
      </div>
    ` : ''}

    ${individuais.map(p => `
      <div class="lex-section">
        <h2>Parecer ${escapeHtml(p.agente)} · ${escapeHtml(p.area_codigo || '')}</h2>
        <div style="padding:18px 24px;line-height:1.6;font-size:13px;color:rgba(255,255,255,0.92)">
          ${mdToHtml(p.parecer_markdown || '')}
        </div>
      </div>
    `).join('')}
  `;
  $('.lex-back', main).addEventListener('click', () => { location.hash = 'consultas'; });
}

// ─── Go ────────────────────────────────────────────────────────────
boot().catch(err => {
  console.error('LEX boot failed', err);
  document.body.innerHTML = `<pre style="color:#fff;padding:24px">${escapeHtml(err.stack || err.message)}</pre>`;
});
